module.exports = __webpack_public_path__ + "static/media/m_55.3bd9a130.png";